<template>
  <div title="Tenant Setup">
    <section class="fulls">
      <div class="container">
         
        <div class=""
          style="">
          <a class="aru" :href="baseUrl">
            <img  :src="'/imgs/aruvaa_logo.png'" alt="" class="my-2 img_size" />
          </a>
        </div>

        <div
          class="block w-1/2 rounded-lg px-5 py-5 mt-4 starte shadow-sm"
          style="background-color: #F9FFFE"
        >
      
          <h6 class="font-semibold text-sm text-green-700" style="">
            NEW PRODUCT TRIAL
          </h6>
          <h3
            class="font-semibold leading-tight text-neutral-800 dark:text-neutral-50"
          >
            Configure your Tenant with Product
            <span class="font-bold text-green-600" style="">{{
              productName
            }}</span>
          </h3>
          <p class="leading-tight text-sm text-gray-600">
           Now You can succesfully Enjoy your free trial for the next 7 days!
          </p>
          <div class="my-4">
           
            <p class="leading-tight text-sm text-gray-600">
              Free trial lets you experience the core functionality of 
              <span class="text-green-600">
              {{productName }}.
            </span>
            </p>
            <p class="support text-sm">If you have any questions, our support team is just an email away at support@aruvaa</p>
           
          </div>
          <button
            type="button"
            @click="deployProductModule()"
            class="block w-full rounded py-1 text-md font-semibold text-white bg-green-500 hover:bg-green-600"
            style=" "
          >
            Setup
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";

export default {
  props: {
    organisationHost: String,
    subscriptionProductId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptinPriceId: String,
    productName: String,
    subscriptionId: String,
  },
  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
  },
  data() {
    return {
      baseUrl: this.$utils.goToUrl(window.env.baseTenantUrl),
    }
  },
  methods: {
     deployProductModule() {
          var data = {
        subscriptionProductId: this.subscriptionProductId,
        organisationHost: this.organisationHost,
        organisationId: this.organisationId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptinPriceId: this.subscriptinPriceId,
        subscriptionId: this.subscriptionId,
        assignRole: this.checked,
      };

      this.$inertia.get(route("tenant-setups.trailsetup","admin"), data);
     }
  },
};
</script>

<style>
.fulls {
  background-color: #ffff !important;
  height: 100vh;
  background-size: cover;
  overflow: hidden;
  padding-top: 4rem;
}
.starte {
  margin: auto;
}
h6 {
  margin-bottom: 0.1rem;
}
.img_size {
  height: auto;
  width: 176px;
}
.aru{
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 13%;
}
p {
  margin-top: 0;
  margin-bottom: 0.1rem;
}
.support{
  color: rgb(5, 61, 38);
}
</style>